exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[data-v-b9872f12], body[data-v-b9872f12] {\n  height: 100%;\n}\nimg[data-v-b9872f12] {\n  max-width: 400px;\n}", ""]);

// exports
